import { styled } from 'linaria/react';
import { css } from 'linaria';
import { media } from '../../../media';

// !important for redefining fronton styles

export const modalHeaderStyles = css`
	${media.mobile} {
		padding-inline: 40px;
		padding-top: 24px;

		h2,
		h3 {
			max-width: 280px;
			padding: 0 !important;
			font-size: 26px !important;
			line-height: 32px !important;
			text-align: left !important;
		}
	}
`;

export const modalContentStyles = css`
	max-height: 572px;
	overflow-y: scroll;
	${media.mobile} {
		max-width: 100vw;
		padding-inline: 16px;
	}
`;

const getTemplateAreas = (address: string | null) =>
	address ? `"name ." "address btn"` : `"name btn"`;

export const ModalRow = styled.div<{ address: string | null }>`
	display: grid;
	align-items: center;
	grid-template-areas: ${({ address }) => getTemplateAreas(address)};
	grid-template-columns: 1fr 126px;
	grid-template-rows: ${({ address }) => (address ? ' max-content 1fr' : 'max-content')};
	max-width: 595px;
	column-gap: 40px;
	border-top: 1px solid var(--control-minor);
	row-gap: 4px;
	padding-block: 16px;

	&:last-child {
		border-bottom: 1px solid var(--control-minor);
	}

	${media.mobile} {
		display: flex;
		flex-direction: column;
		align-items: start;
		margin-top: 16px;
		margin-bottom: 24px;
		border: none;
		padding-block: 0;
		padding-inline: 24px;
		row-gap: 0;
		&:first-child {
			border: none;
		}
	}
`;

export const addressStyles = css`
	grid-area: address;
	${media.mobile} {
		margin-bottom: 12px;
	}
`;

export const nameStyles = css`
	grid-area: name;
	${media.mobile} {
		margin-bottom: 16px;
	}
`;

export const buttonStyles = css`
	grid-area: btn;
	width: 100%;
	max-height: 32px;
`;
